define([], function () {
    "use strict";
    var tzOffsets;

    //SHA256算法
    var CryptoJS=CryptoJS||function(h,s){var f={},t=f.lib={},g=function(){},j=t.Base={extend:function(a){g.prototype=this;var c=new g;a&&c.mixIn(a);c.hasOwnProperty("init")||(c.init=function(){c.$super.init.apply(this,arguments)});c.init.prototype=c;c.$super=this;return c},create:function(){var a=this.extend();a.init.apply(a,arguments);return a},init:function(){},mixIn:function(a){for(var c in a)a.hasOwnProperty(c)&&(this[c]=a[c]);a.hasOwnProperty("toString")&&(this.toString=a.toString)},clone:function(){return this.init.prototype.extend(this)}},
    	q=t.WordArray=j.extend({init:function(a,c){a=this.words=a||[];this.sigBytes=c!=s?c:4*a.length},toString:function(a){return(a||u).stringify(this)},concat:function(a){var c=this.words,d=a.words,b=this.sigBytes;a=a.sigBytes;this.clamp();if(b%4)for(var e=0;e<a;e++)c[b+e>>>2]|=(d[e>>>2]>>>24-8*(e%4)&255)<<24-8*((b+e)%4);else if(65535<d.length)for(e=0;e<a;e+=4)c[b+e>>>2]=d[e>>>2];else c.push.apply(c,d);this.sigBytes+=a;return this},clamp:function(){var a=this.words,c=this.sigBytes;a[c>>>2]&=4294967295<<
    	32-8*(c%4);a.length=h.ceil(c/4)},clone:function(){var a=j.clone.call(this);a.words=this.words.slice(0);return a},random:function(a){for(var c=[],d=0;d<a;d+=4)c.push(4294967296*h.random()|0);return new q.init(c,a)}}),v=f.enc={},u=v.Hex={stringify:function(a){var c=a.words;a=a.sigBytes;for(var d=[],b=0;b<a;b++){var e=c[b>>>2]>>>24-8*(b%4)&255;d.push((e>>>4).toString(16));d.push((e&15).toString(16))}return d.join("")},parse:function(a){for(var c=a.length,d=[],b=0;b<c;b+=2)d[b>>>3]|=parseInt(a.substr(b,
    	2),16)<<24-4*(b%8);return new q.init(d,c/2)}},k=v.Latin1={stringify:function(a){var c=a.words;a=a.sigBytes;for(var d=[],b=0;b<a;b++)d.push(String.fromCharCode(c[b>>>2]>>>24-8*(b%4)&255));return d.join("")},parse:function(a){for(var c=a.length,d=[],b=0;b<c;b++)d[b>>>2]|=(a.charCodeAt(b)&255)<<24-8*(b%4);return new q.init(d,c)}},l=v.Utf8={stringify:function(a){try{return decodeURIComponent(escape(k.stringify(a)))}catch(c){throw Error("Malformed UTF-8 data");}},parse:function(a){return k.parse(unescape(encodeURIComponent(a)))}},
    	x=t.BufferedBlockAlgorithm=j.extend({reset:function(){this._data=new q.init;this._nDataBytes=0},_append:function(a){"string"==typeof a&&(a=l.parse(a));this._data.concat(a);this._nDataBytes+=a.sigBytes},_process:function(a){var c=this._data,d=c.words,b=c.sigBytes,e=this.blockSize,f=b/(4*e),f=a?h.ceil(f):h.max((f|0)-this._minBufferSize,0);a=f*e;b=h.min(4*a,b);if(a){for(var m=0;m<a;m+=e)this._doProcessBlock(d,m);m=d.splice(0,a);c.sigBytes-=b}return new q.init(m,b)},clone:function(){var a=j.clone.call(this);
    	a._data=this._data.clone();return a},_minBufferSize:0});t.Hasher=x.extend({cfg:j.extend(),init:function(a){this.cfg=this.cfg.extend(a);this.reset()},reset:function(){x.reset.call(this);this._doReset()},update:function(a){this._append(a);this._process();return this},finalize:function(a){a&&this._append(a);return this._doFinalize()},blockSize:16,_createHelper:function(a){return function(c,d){return(new a.init(d)).finalize(c)}},_createHmacHelper:function(a){return function(c,d){return(new w.HMAC.init(a,
    	d)).finalize(c)}}});var w=f.algo={};return f}(Math);
    	(function(h){for(var s=CryptoJS,f=s.lib,t=f.WordArray,g=f.Hasher,f=s.algo,j=[],q=[],v=function(a){return 4294967296*(a-(a|0))|0},u=2,k=0;64>k;){var l;a:{l=u;for(var x=h.sqrt(l),w=2;w<=x;w++)if(!(l%w)){l=!1;break a}l=!0}l&&(8>k&&(j[k]=v(h.pow(u,0.5))),q[k]=v(h.pow(u,1/3)),k++);u++}var a=[],f=f.SHA256=g.extend({_doReset:function(){this._hash=new t.init(j.slice(0))},_doProcessBlock:function(c,d){for(var b=this._hash.words,e=b[0],f=b[1],m=b[2],h=b[3],p=b[4],j=b[5],k=b[6],l=b[7],n=0;64>n;n++){if(16>n)a[n]=
    	c[d+n]|0;else{var r=a[n-15],g=a[n-2];a[n]=((r<<25|r>>>7)^(r<<14|r>>>18)^r>>>3)+a[n-7]+((g<<15|g>>>17)^(g<<13|g>>>19)^g>>>10)+a[n-16]}r=l+((p<<26|p>>>6)^(p<<21|p>>>11)^(p<<7|p>>>25))+(p&j^~p&k)+q[n]+a[n];g=((e<<30|e>>>2)^(e<<19|e>>>13)^(e<<10|e>>>22))+(e&f^e&m^f&m);l=k;k=j;j=p;p=h+r|0;h=m;m=f;f=e;e=r+g|0}b[0]=b[0]+e|0;b[1]=b[1]+f|0;b[2]=b[2]+m|0;b[3]=b[3]+h|0;b[4]=b[4]+p|0;b[5]=b[5]+j|0;b[6]=b[6]+k|0;b[7]=b[7]+l|0},_doFinalize:function(){var a=this._data,d=a.words,b=8*this._nDataBytes,e=8*a.sigBytes;
    	d[e>>>5]|=128<<24-e%32;d[(e+64>>>9<<4)+14]=h.floor(b/4294967296);d[(e+64>>>9<<4)+15]=b;a.sigBytes=4*d.length;this._process();return this._hash},clone:function(){var a=g.clone.call(this);a._hash=this._hash.clone();return a}});s.SHA256=g._createHelper(f);s.HmacSHA256=g._createHmacHelper(f)})(Math);

    
    
    //该方法慎用(已确认tiny 53版本有问题，调用textBox的option方法会导致其他输入框无法获取焦点)。
    function trimSpace(inputId) {
        $("#" + inputId).widget().option("value", getTrimValue(inputId));
    }

    function getTrimValue(inputId){
        var inputField = $("#" + inputId).widget();
        var value;
        inputField ? value = $.trim(inputField.getValue()) : value = "";
        return value.replace(/\s+/g, function (match, capture) {
            return " ";
        });
    }

    function getUrlParams() {
        var urlParams = {};
        var searchStr = window.location.search.substring(1);
        var params = searchStr.split("&");
        for (var index = 0; index < params.length; index++) {
            var key = params[index].substring(0, params[index].indexOf("="));
            var value = params[index].substring(params[index].indexOf("=") + 1).replace(/\+/g, encodeURIComponent(' '));
            urlParams[key] = decodeURIComponent(value);
        }
        return urlParams;
    }

    function i18nFormat() {
        if (arguments.length === 1) {
            return arguments[0];
        }
        var regex = /{\d+}/g;
        var args = arguments;
        return args[0].replace(regex, function (m, i) {
            var index = parseInt(m.substr(1, m.length - 1)) + 1;
            return args[index] != undefined ? args[index] : m;
        });
    }

    function getPwdStrengthLevel(pwd, password_char_combination) {
        var modes = 0;
        for (var i = 0; i < pwd.length; i++) {
            //测试每一个字符的类别并统计一共有多少种模式.
            modes |= charMode(pwd.charCodeAt(i));
        }

        //测试某个字符是属于哪一类.
        function charMode(iN) {
            if (iN >= 48 && iN <= 57) //数字
                return 1;
            if (iN >= 65 && iN <= 90) //大写字母
                return 2;
            if (iN >= 97 && iN <= 122) //小写
                return 4;
            else
                return 8; //特殊字符
        }

        //计算出当前密码当中一共有多少种模式
        function bitTotal(num) {
            var modes = 0;
            for (var i = 0; i < 4; i++) {
                if (num & 1) {
                    modes++;
                }
                num >>>= 1;
            }
            return modes;
        }

        function getLevel(allBits) {
            if (password_char_combination) {
                if (allBits < password_char_combination) {
                    return "low";
                } else if (allBits === password_char_combination) {
                    return "mid";
                } else if (allBits > password_char_combination) {
                    return "high";
                } else {
                    return "low";
                }
            } else {
                switch (allBits) {
                    case 4:
                    case 3:
                        return "high";
                    case 2:
                        return "mid";
                    case 1:
                        return "low";
                    default:
                        return "low";
                }
            }
        }

        return getLevel(bitTotal(modes));
    }

    function pwdLevel4Display(lowId, midId, highId) {
        return {
            params: [lowId, midId, highId],
            validFn: function (params) {
                var defaultColor = "#e2e2e2"; //#D0D0D0
                var lowColor = "#FF4C4C"; //"#FF7D73 #ff4c4c";
                var midColor = "#FF8833"; //"#FFD42A #ff6a00";
                var highColor = "#3dcca6"; //"#A3E000 #0a9e00"
                var low;
                var mid;
                var high;
                var level;
                var pwd = this.val();
                
                if (pwd == null || pwd == '') {
                    low = mid = high = defaultColor;
                    switchClazz('');
                }else{
                    if(pwd.length < 6){
                        level = 'low';
                    }else{
                        level = getPwdStrengthLevel(pwd);
                    }
                    
                    switch (level) {
                        case "high":
                            low = mid = high = highColor;
                            switchClazz('high');
                            $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "4px";
                            break;
                        case "low":
                            low = lowColor;
                            mid = high = defaultColor;
                            switchClazz('low');
                            $("#" + lowId)[0].style.height = "4px";
                            $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
                            break;
                        case "mid":
                            low = mid = midColor;
                            high = defaultColor;
                            switchClazz('mid');
                            $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = "4px";
                            $("#" + highId)[0].style.height = "2px";
                            break;
                        default:
                            low = mid = high = defaultColor;
                            $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
                            switchClazz('');
                    }
                }
                
                $("#" + params[0])[0].style.background = low;
                $("#" + params[1])[0].style.background = mid;
                $("#" + params[2])[0].style.background = high;
                return true;
            }
        }
    }
    
    function switchClazz(clazz){
        try{
            $("#TIP").removeClass('high');
            $("#TIP").removeClass('low');
            $("#TIP").removeClass('mid');
            $("#TIP").addClass(clazz);
        }catch (e) {
        }
    }

    function clearPwdDisplayLevel(lowId, midId, highId) {
        try{
            $("#" + lowId)[0].style.backgroundColor = "#D0D0D0";
            $("#" + midId)[0].style.backgroundColor = "#D0D0D0";
            $("#" + highId)[0].style.backgroundColor = "#D0D0D0";
            switchClazz('');
        }catch(e){
            console.dir(e);
        }
      
    }

    function setPwdLevel(lowId, midId, highId, pwd, pwdLvlColors) {
        var level = '';
        if(pwd == null || pwd == '') {
            level = '';
        } else if (pwd.length < 6) {
            level = 'low';
        } else {
            level = getPwdStrengthLevel(pwd);
        }

        setPwdLevelByLevel(lowId, midId, highId, level, pwdLvlColors);
    }

    function setPwdLevelByLevel(lowId, midId, highId, level, pwdLvlColors) {
        var defaultColor = "#e2e2e2"; //#D0D0D0
        var lowColor="#ff4c4c"; //"#FF7D73";
        var midColor = "#ff6a00"; //"#FFD42A";
        var highColor = "#0a9e00"; //"#A3E000"
        if(pwdLvlColors && pwdLvlColors.length >= 4){
            defaultColor = pwdLvlColors[0];
            lowColor = pwdLvlColors[1];
            midColor = pwdLvlColors[2];
            highColor = pwdLvlColors[3];
        }
        var low;
        var mid;
        var high;
        switch (level) {
            case "high":
                low = mid = high = highColor;
                switchClazz('high');
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "4px";
                break;
            case "low":
                low = lowColor;
                mid = high = defaultColor;
                switchClazz('low');
                $("#" + lowId)[0].style.height = "4px";
                $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
                break;
            case "mid":
                low = mid = midColor;
                high = defaultColor;
                switchClazz('mid');
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = "4px";
                $("#" + highId)[0].style.height = "2px";
                break;
            default:
                low = mid = high = defaultColor;
                switchClazz('');
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
        }

        if ($("#" + lowId).size() != 0) {
            $("#" + lowId)[0].style.background = low;
            $("#" + midId)[0].style.background = mid;
            $("#" + highId)[0].style.background = high;
        }
    }

    function getEmailURL(emailURL) {
        var domainURLs = {
            'yeah.net': "http://www.yeah.net/",
            'sogou.com': "http://mail.sogou.com/",
            '188.com': "http://www.188.com/index.htm?from=h2",
            'x263.net': "http://mail.263.net/",
            '263.net.cn': "http://mail.263.net/",
            '263.net': "http://mail.263.net/",
            '21cn.com': "http://mail.21cn.com/",
            'eyou.com': "http://www.eyou.com/",
            'yahoo.com': "http://cn.mail.yahoo.com/",
            'yahoo.com.cn': "http://cn.mail.yahoo.com/",
            'yahoo.cn': "http://cn.mail.yahoo.com/",
            'foxmail.com': "http://mail.qq.com/",
            'qq.com': "http://mail.qq.com/",
            'LIVE.COM': "http://www.hotmail.com/",
            'LIVE.CN': "http://www.hotmail.com/",
            'hotmail.com': "http://www.hotmail.com/",
            'gmail.com': "http://mail.google.com/",
            '139.com': "http://mail.139.com/",
            '126.com': "http://www.126.com/",
            'tom.com': "http://mail.tom.com/",
            'vip.tom.com': "http://mail.tom.com/",
            '163.net': "http://mail.tom.com/",
            'sohu.com': "http://login.mail.sohu.com/",
            'sina.com': "http://mail.sina.com.cn/",
            'sina.cn': "http://mail.sina.com.cn/",
            '2008.sina.com': "http://mail.sina.com.cn/",
            '163.com': "http://mail.163.com/",
            'huawei.com': "http://imail.huawei.com/"
        };
        var domain = emailURL.split("@")[1];
        if (domain in domainURLs) {
            return domainURLs[domain];
        }
        return "";
    }

    function getMessageInstance(width, i18n) {
        return {
            ERROR: getHandlerByType("error", width, i18n),
            PROMPT: getHandlerByType("prompt", width, i18n),
            CONFIRM: getHandlerByType("confirm", width, i18n),
            WARN: getHandlerByType("warn", width, i18n)
        };
    }

    function getMobileMessageInstance(width, i18n) {
        return {
            "ERROR": getMobileHandlerByType("error", width, i18n),
            "PROMPT": getMobileHandlerByType("prompt", width, i18n),
            "CONFIRM": getMobileHandlerByType("confirm", width, i18n),
            "WARN": getMobileHandlerByType("warn", width, i18n)
        }
    }

    function getMobileHandlerByType(type, width, i18n) {
        return function (content, detail, id, buttons, closeCallback) {
            createTipDiv(content);
            $("#TipDiv").show();
            setTimeout(function () {
                $("#TipDiv").remove();
                closeCallback && closeCallback();
            }, 2000);

        }
    }

    function createTipDiv(tipInfo) {
        var tipDiv = '<p id="TipDiv" style="background: rgba(0, 0, 0, 0.8); text-align: center; line-height: 16px;color: #fff; ' +
            'position: absolute;left: 16%;top: 50%;-webkit-border-radius: 2px;z-index: 9999;display: block; padding: 15px 17px;' +
            'transform: translate(-10%, -50%);-webkit-transform: translate(-10%, -50%); width: 84%; font-size: 16px;">' + tipInfo + '</p>';
        $("#TipDiv").remove();
        $(document.body).append(tipDiv);
    }
    function setPwdLevel4Hws(lowId, midId, highId, flag, value, i18n, pwdMinLen, levelChar) {
        var level = "";
        if (value == null || value == '') {
            level = "";
        } else {
            if (levelChar === "low" || value.length < pwdMinLen) {
                level = "low";
            } else if (levelChar === "mid") {
                level = "mid";
            } else {
                level = getPwdStrengthLevel(value);
            }
        }
        setPwdLvlByLvl(lowId, midId, highId, flag, level, i18n);
    }
    
    function setPwdLvlByLvl(lowId, midId, highId, flag, level, i18n) {
        var defaultColor = "#e2e2e2";
        var lowColor = "#ff4c4c";
        var midColor = "#ff6a00";
        var highColor = "#0a9e00";
        var low;
        var mid;
        var high;
        var flagStr = "";
        switch (level) {
            case "high":
                low = mid = high = highColor;
                flagStr = "&nbsp;&nbsp;" + i18n("strengthHigh");
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "4px";
                break;
            case "low":
                low = lowColor;
                mid = high = defaultColor;
                flagStr = "&nbsp;&nbsp;" + i18n("strengthLow");
                $("#" + lowId)[0].style.height = "4px";
                $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
                break;
            case "mid":
                low = mid = midColor;
                high = defaultColor;
                flagStr = "&nbsp;&nbsp;" + i18n("strengthMid");
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = "4px";
                $("#" + highId)[0].style.height = "2px";
                break;
            default:
                low = mid = high = defaultColor;
                flagStr = "&nbsp;&nbsp;";
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
        }
        if ($("#" + flag).size() != 0) {
            $("#" + flag)[0].innerHTML = flagStr;
        }
        if ($("#" + lowId).size() != 0) {
            $("#" + lowId)[0].style.background = low;
            $("#" + midId)[0].style.background = mid;
            $("#" + highId)[0].style.background = high;
        }
    }
    function validatePasswdNameSHA256(value, userName) {
    	// 比较SHA256的值以保护用户隐私
    	if (userName && (CryptoJS.SHA256(value.toLowerCase()).toString() === userName || CryptoJS.SHA256(value.split("").reverse().join("").toLowerCase()).toString() === userName)) {
            return false;
        }
        return true;
    }
    
    function validatePasswdName(value, userName) {
    	if (userName && (value.toLowerCase() === userName.toLowerCase() || value.toLowerCase() === userName.split("").reverse().join("").toLowerCase())) {
            return false;
        }
        return true;
    }
    
    function removeErrorInfo(id) {
        if($(id)[0].hasChildNodes())
        {
            $(id).empty();
        }
    }
    function showOKImage(infoid) {
        var imgSrc = require("custom/images/verifycode_success.png");
        var imgDom = '<img style="margin-top: 19px;float:left;" src="' + imgSrc+ '"/>';
        $(infoid).html(imgDom);
    }
    function addErrorTip(errorTxt, errorInfoid) {
        var imgSrc = require("custom/images/verifycode_valid.png");
        var errorDomFragment = '<span><img style="margin-top: -1px;" src="' + imgSrc + '">&nbsp;' + errorTxt + '</span>';
        if(errorDomFragment.replace(/\//ig,"")!==$(errorInfoid).html().replace(/\//ig,"")){
            removeErrorInfo(errorInfoid);
        }else{
            return;
        }
        $(errorInfoid).html(errorDomFragment);
    }
    
    function maxRptCharTimes(value,contSameCharLen){
        if(value === undefined || contSameCharLen === 0)
        {
            return true;
        }
        if(searchMaxString(value) > contSameCharLen || value.length === 0)
        {
            return false;
        }
        return true;
    }
    
    function searchMaxString (origString) {
        var stringLen = origString.length;
        var maxLength = 1;
        var index = 1;
        var flagChar = origString.charAt(0);
        for(var i=0; i<stringLen;) {
            index = 1;
            for(var j=i+1; j<stringLen; j++){
                if(flagChar == origString.charAt(j)) {
                    index ++;
                }
                else {
                    break;
                }
            }
            if(index > maxLength) {
                maxLength = index;
            }
            i = j;
            flagChar = origString.charAt(i);
        }
        return maxLength;
    }

    function getHandlerByType(type, width, i18n) {
        return function (content, detail, id, buttons, closeCallback) {
            var options = {
                type: type,
                content: content,
                "detail-msg": detail,
                width: width,
                "append-to": "#" + id,
                buttons: []
            };
            switch (type) {
                case "error": options.title = i18n("title.error"); break;
                case "prompt": options.title = i18n("title.prompt"); break;
                case "confirm": options.title = i18n("title.confirm"); break;
                case "warn": options.title = i18n("title.warn"); break;
            }
            var msg = new tinyWidget.Message(options);
            if (buttons === undefined || buttons.length === 0) {
                var btns = [{
                    key: "btnId2",
                    label: i18n("btnTxtOK"),
                    focused: false,
                    handler: function (event) {
                        msg.destroy();
                    }
                }];
                msg.option("buttons", btns);
            }
            else {
                msg.buttonHandlers = {};
                for (var index = 0; index < buttons.length; index++) {
                    msg.buttonHandlers[buttons[index].label] = buttons[index].handler;
                    buttons[index].handler = function (event) {
                        var originalHandler = msg.buttonHandlers[event.value];
                        msg.destroy();
                        if (originalHandler) {
                            originalHandler();
                        }
                    };
                }
                msg.option("buttons", buttons);
            }

            if (closeCallback) {
                msg.on("close", closeCallback);
            }
            msg.show();
        }
    }

    function getSecurityMasker() {
        return {
            maskMobile: function (mobile) {
                if (mobile === "" || mobile === undefined) {
                    return "";
                }

                var countryCode = "";
                var mobileNumber = "";
                if (mobile.indexOf("-") !== -1) {
                    countryCode = mobile.split("-")[0] + "-";
                    mobileNumber = mobile.split("-")[1];
                } else {
                    mobileNumber = mobile;
                }

                if (mobileNumber.length > 5) {
                    return countryCode + mobileNumber.substr(0, 3) + "****" + mobileNumber.substr(mobileNumber.length - 2, mobileNumber.length);
                } else if (mobileNumber.length > 3) {
                    return countryCode + mobileNumber.substr(0, 3) + "****";
                } else {
                    return countryCode + mobileNumber + "****";
                }
            },
            maskEmail: function (email) {
                if (!email) {
                    return "******";
                }
                if (email.indexOf("@") === -1) {
                    return "******";
                }
                var pair = email.split("@");
                if (pair.length !== 2) {
                    return "******";
                }
                var pref = pair[0];
                var len = pref.length;
                var beginString = len < 2 ? pref : pref.substring(0, 1);
                var endString = len > 2 ? pref.substring(len - 1, len) : "";
                var maskEmail = "";
                if (len === 2 || len === 3) {
                    maskEmail = "*";
                } else if (len === 4) {
                    maskEmail = "**";
                } else if (len > 4) {
                    maskEmail = "***";
                }
                return beginString + maskEmail + endString + "@" + pair[1];
            }
        };
    }

    function SortArray(sortStr){
        var sortCode = function(a,b)
        {
            a = a[sortStr];
            a = a.substring(a.indexOf("(")+1 , a.indexOf(")"));
            b = b[sortStr];
            b = b.substring(b.indexOf("(")+1 , b.indexOf(")"));
            return a.localeCompare(b);
        }
        return sortCode;
    }
    function getCodeValue(codeObj,value){
        var codeValue;
        for(var item in codeObj){
            if(codeObj[item].label === value){
               codeValue = codeObj[item].id;
            }
        }
        return codeValue;
    }
    function getCountryValue(codeObj,value){
        var countryValue;
        for(var item in codeObj){
            if(codeObj[item].id === value){
                countryValue = codeObj[item].label;
            }
        }
        return countryValue;
    }

    function getPhoneRegex(countryCode, regexJson){
        if(!regexJson){
            return;
        }
        var pattern = regexJson[countryCode];
        return pattern;
    }
    function getCountryCode($scope){
        $.ajax({
            type:"GET",
            url:"/authui/getCountryCode",
            contentType: "charset=UTF-8",
            async: false,
            success:function(data){
                var data = typeof data === 'object' ? data : $.parseJSON(data);
                var codeList = data["codeArray"];
                $scope.model.defaultCode = data["defaultCode"];
                $scope.model.phoneLenObj = data["phoneLen"];
                if (codeList.length) {
                    codeList = codeList.sort(SortArray('label'));
                    $scope.model.codeJson = codeList;
                    for(var item in codeList){
                        $scope.model.codeArray.push(codeList[item].label);
                    }
                    $scope.model.codeValues =  $scope.model.codeArray;
                    $scope.model.defaultValue = getCountryValue($scope.model.codeJson, $scope.model.defaultCode);
                    $scope.model.codeValues =  $scope.model.codeArray;
                    $scope.$evalAsync();
                }
            }
        })
    }
    function getPubPhoneLen(codeObj, phoneLenObj){
        if(!phoneLenObj){
            return 32;
        }
        var countryCode = getCodeValue(codeObj, $("#codeSelectId").widget().getValue());
        if(getPhoneRegex(countryCode, phoneLenObj)){
            return getPhoneRegex(countryCode, phoneLenObj);
        }
        return 32;
    }
    function UTCtoLocal(UTCTime, format) {
        var utcTime = new Date(UTCTime.replace(/-/g,"/"));  //保证浏览器兼容
        var localTime = new Date(utcTime.getTime() - utcTime.getTimezoneOffset()*1000*60);

        if (tzOffsets === undefined) {
            tzOffsets = getTzOffsets();
        }
        if (tzOffsets[0] !== tzOffsets[1]) {
            //timezone has DST
            var tzOffset = localTime.getTimezoneOffset();
            if (tzOffset === tzOffsets[0]) {
                //DST
                return getTimeString(localTime) + " DST";
            }
        }
        return getTimeString(localTime);

        function getTimeString (date) {
            function normalize (str) {
                return str.length < 2 ? "0" + str : str;
            }

            var time = normalize(date.getHours() + "") + ":" + normalize(date.getMinutes() + "") + ":" + normalize(date.getSeconds() + "");
            if(format.toLowerCase() === "dd-mm-yyyy hh:mm:ss")
            {
                return normalize(date.getDate() + "") + "-" + normalize(date.getMonth() + 1 + "")  + "-" + date.getFullYear() + " " + time;
            }
            if(format.toLowerCase() === "mm-dd-yyyy hh:mm:ss")
            {
                return normalize(date.getMonth() + 1 + "") + "-" + normalize(date.getDate() + "")  + "-" + date.getFullYear() + " " + time;
            }
            return date.getFullYear() + "-" + normalize(date.getMonth() + 1 + "") + "-" + normalize(date.getDate() + "") + " " + time;
        }

        function getTzOffsets () {
            var arr = [];
            for (var i = 0; i < 365; i++) {
                var d = new Date();
                d.setDate(i);
                var newOffset = d.getTimezoneOffset();  //东半球为负，西半球为正， DST提前一个小时
                arr.push(newOffset);
            }
            var DST = Math.min.apply(null, arr);
            var nonDST = Math.max.apply(null, arr);

            return [DST, nonDST];
        }
    }

    function getCurrentTimeZone() {
        var minutes = new Date().getTimezoneOffset();
        var hour = parseInt(minutes / 60, 10);
        var munite = minutes % 60;
        var prefix = '-';
        if (hour < 0 || munite < 0) {
            prefix = '+';
            hour = -hour;
            if (munite < 0) {
                munite = -munite;
            }
        }
        hour = hour + '';
        munite = munite + '';
        if (hour.length === 1) {
            hour = '0' + hour;
        }
        if (munite.length === 1) {
            munite = '0' + munite;
        }
        return 'GMT' + prefix + hour + ':' + munite;
    }

    function getMailbox(value, $scope) {
        function isCompleted(value, suggestions) {
            if (-1 !== value.indexOf("@"))return !0;
            for (var i = 0; i < suggestions.length; i++)if (0 === suggestions[i].label.indexOf(value))return !0;
            return !1
        }

        var i, list = [{"id": "1", "label": "@163.com"}, {"id": "2", "label": "@sina.com"}, {
            "id": "3",
            "label": "@huawei.com"
        }, {"id": "4", "label": "@qq.com"}, {"id": "5", "label": "@gmail.com"}, {
            "id": "6",
            "label": "@126.com"
        }, {"id": "7", "label": "@yahoo.com"}, {"id": "8", "label": "@sohu.com"}];
        if (isCompleted(value, $scope.model.suggestions))return;
        for (i = 0; i < list.length; i++)list[i].label = value + list[i].label;
        $scope.model.suggestions = list
    }

    function getAuthenticationUrl(url, authenUrl){
        var searchParam = "";
        if(url.indexOf("?") !== -1 && url.indexOf("service") !== -1){
            searchParam = url.substring(url.indexOf("?") + 1);
        }
        if(!searchParam){
            url = url + "&service=" + encodeURIComponent(authenUrl);
            return url;
        }
        var params = searchParam.split("&");
        for (var index = 0; index < params.length; index++) {
            var key = params[index].substring(0, params[index].indexOf("="));
            var value = params[index].substring(params[index].indexOf("=") + 1);
            if(key === 'service'){
                url = url.replace(value, encodeURIComponent(authenUrl));
                return url;
            }
        }
        return url;
    }

    function validateCharNum(value, contSameCharLen) {
        if (contSameCharLen == 0)
        {
            return true;
        }
        var num = 1;
        var finalNum = 1;
        var char = value.charAt(0);
        for(var i = 1; i < value.length; i++)
        {
            if (char == value.charAt(i))
            {
                num ++;
                finalNum = num >= finalNum ? num : finalNum;
            }
            else
            {
                char = value.charAt(i);
                num = 1;
            }
        }
        return finalNum <= contSameCharLen;
    }

    function validatePasswdChar(value, password_char_combination) {
        var invalidChars = new RegExp("[\u4e00-\u9fa5]+");
        if (invalidChars.test(value)) {
            return false;
        }
        if (getPwdStrengthLevel(value, password_char_combination) !== "high" && getPwdStrengthLevel(value, password_char_combination) !== "mid") {
            return false;
        }
        return true;
    }

    function buildTip(number, chars, maxSameChars, notEqualName, notContsMobile, i18n){
         const defaultPng = require('custom/images/default.png');
         var tip = "<div class='tip-div' style='font-size:12px;font-family:Arial;color:#050505;margin: 5px 0 5px 10px;'>"
                   + "<img id='minLenId' class='tootip-img' src='" + defaultPng + "'></img>&nbsp;&nbsp;"
                   + "<div class='tootip-div'>" + number + "</div>"
                   + "<img id='containsCharsId' class='tootip-img' src='" + defaultPng + "'></img>&nbsp;&nbsp;"
                   + "<div class='tootip-div'>" + chars + "</div>";
         if(maxSameChars)
         {
            tip = tip + "<img id='maxSameCharsId' class='tootip-img' src='" + defaultPng + "'></img>&nbsp;&nbsp;"
            + "<div id='maxSameCharsLabel' class='tootip-div'>" + maxSameChars + "</div>";
         }
         if(notEqualName)
         {
            tip = tip + "<img id='notNameId' class='tootip-img' src='" + defaultPng + "'></img>&nbsp;&nbsp;"
            + "<div class='tootip-div'>" + notEqualName + "</div>";
         }
         if(notContsMobile)
         {
            tip = tip + "<img id='notContsId' class='tootip-img' src='" + defaultPng + "'></img>&nbsp;&nbsp;"
            + "<div class='tootip-div'>" + notContsMobile + "</div>";
         }
         tip = tip + "<div ><div  style='display:inline-block;margin-left:-8px;height:20px;'><span style='float:right' id='strengthflag'></span><span id='strengthHigh' class='passwordStrength' style='margin:0;position:relative;top:50%;transform:translateY(-50%);'></span><span id='strengthMid' class='passwordStrength' style='margin:0;position:relative;top:50%;transform:translateY(-50%);'></span><span id='strengthLow' class='passwordStrength' style='margin:0;position:relative;top:50%;transform:translateY(-50%);'></span><span style='display: inline-block;float:left;margin-left:27px;margin-right:10px;'>"
             + i18n("safetyDegree") + "</span></div></div>"
             + "</div>";
         return tip;
    }

    function getInputObj(id){
        var inputObj = $("#" + id);
        if (inputObj[0].tagName !== "INPUT") {
            inputObj = $("#" + id + " input");
        }
        return inputObj;
    }

    return {
        i18nFormat: i18nFormat,
        trimSpace: trimSpace,
        getTrimValue: getTrimValue,
        getUrlParams: getUrlParams,
        getPwdStrengthLevel: getPwdStrengthLevel,
        pwdLevel4Display: pwdLevel4Display,
        clearPwdDisplayLevel: clearPwdDisplayLevel,
        getEmailURL: getEmailURL,
        getMessageInstance: getMessageInstance,
        getMobileMessageInstance:getMobileMessageInstance,
        getSecurityMasker: getSecurityMasker,
        SortArray: SortArray,
        getCodeValue:getCodeValue,
        getCountryValue:getCountryValue,
        UTCtoLocal:UTCtoLocal,
        setPwdLevel:setPwdLevel,
        setPwdLevelByLevel:setPwdLevelByLevel,
        getPhoneRegex: getPhoneRegex,
        getCountryCode:getCountryCode,
        getPubPhoneLen: getPubPhoneLen,
        getMailbox:getMailbox,
        EmailRegex: /^((([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/,
        getCurrentTimeZone: getCurrentTimeZone,
        validateCharNum: validateCharNum,
        validatePasswdChar: validatePasswdChar,
        validatePasswdName: validatePasswdName,
        validatePasswdNameSHA256: validatePasswdNameSHA256,
        showOKImage: showOKImage,
        addErrorTip: addErrorTip,
        removeErrorInfo: removeErrorInfo,
        maxRptCharTimes: maxRptCharTimes,
        setPwdLvlByLvl: setPwdLvlByLvl,
        setPwdLevel4Hws: setPwdLevel4Hws,
        buildTip: buildTip,
        getInputObj: getInputObj,
        getAuthenticationUrl: getAuthenticationUrl
    };
});



// WEBPACK FOOTER //
// ./public/base/utils/utility.js